import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { queryApiDetail } from '../../../api';
import styles from './index.module.scss';
import BaseInfo from './BaseInfo';
import APIInfoLay from './APIInfo';

type ApiDetailType = {
  title?: string,
  provider?: string,
  description?: string,
  invokeFrequency?: number,
  apiId?: number,
  apiKind?: number,
  apiState?: number,
  createTime?: number,
  author?: string,
  popularity?:number,
  delay?: number
}

const APIDetailLay: React.FC = (props:any) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState<Number>(1);
  const [apidetail, setApidetail] = useState<ApiDetailType>({});
  const switchTab = (num: Number) => {
    setCurrentTab(num);
    console.log(props);
  };

  // eslint-disable-next-line consistent-return
  const handlerQueryApiDetail = async () => {
    if (!props.match.params.apiId) {
      return false;
    }
    const result: any = await queryApiDetail(props.match.params.apiId);
    console.log('result', result);
    if (result.code === 0) {
      setApidetail(result.data);
    }
  };
  useEffect(() => {
    handlerQueryApiDetail();
    // eslint-disable-next-line
  }, []);
  return (
    <div
      className={styles.detailLayout}
      style={{
        marginTop: '40px',
      }}
    >
      <div className={styles.top_detail}>
        <div className={styles.img_areas}>
          <img src="https://www.sagamarket.io/img/icons/Tool.svg" alt="" />
        </div>
        <div className={styles.main_dag}>
          <div className={styles.main_titles}>{apidetail.title}</div>
          <div className={styles.main_title_desc}>{apidetail.description}</div>
          <div className={styles.percend}>
            <div className={styles.per_item}>
              <div className={styles.per_title}>{t('use_count')}</div>
              <div className={styles.per_num}>{apidetail.invokeFrequency}</div>
            </div>
            <div className={styles.per_item}>
              <div className={styles.per_title}>{t('popularity')}</div>
              <div className={styles.per_num}>
                {apidetail.popularity}
                %
              </div>
            </div>
            <div className={styles.per_item}>
              <div className={styles.per_title}>{t('latency')}</div>
              <div className={styles.per_num}>
                {apidetail.delay}
                s
              </div>
            </div>
          </div>
          <div className={styles.btn_down}>{t('set_default')}</div>
        </div>
      </div>
      <div className={styles.api_message_layout}>
        <ul className={styles.tab_switch}>
          {/* eslint-disable-next-line max-len */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
          <li
            className={currentTab === 1 ? styles.active : ''}
            onClick={() => {
              switchTab(1);
            }}
          >
            {t('function_word')}
          </li>
          {/* eslint-disable-next-line max-len */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
          <li
            className={currentTab === 2 ? styles.active : ''}
            onClick={() => {
              switchTab(2);
            }}
          >
            API
          </li>
        </ul>
      </div>
      <div className={styles.btnInfo}>
        {currentTab === 1 && <BaseInfo description={apidetail.description} />}
        {/* eslint-disable-next-line max-len */}
        {currentTab === 2 && <APIInfoLay provider={apidetail.provider} createTime={apidetail.createTime} />}
      </div>
    </div>
  );
};

export default withRouter(APIDetailLay);
